export type FieldType = 'string' | 'number' | 'boolean' | 'string[]' | 'column' | 'column[]';

export interface FieldSchema {
  type: FieldType;
  required?: boolean;
  default?: any;
  allowedValues?: any[];
}

export type ParameterSchema<T> = {
  [K in keyof T]: FieldSchema;
};

// validate-parameters.ts

export interface ValidationError {
  field: string;
  message: string;
}

const typeCheckers: Record<FieldType, (v: any) => boolean> = {
  string: v => typeof v === 'string',
  number: v => typeof v === 'number',
  boolean: v => typeof v === 'boolean',
  'string[]': v => Array.isArray(v) && v.every(i => typeof i === 'string'),
  column: v => typeof v === 'string',
  'column[]': v => Array.isArray(v) && v.every(i => typeof i === 'string'),
};

export function validateParameters(
  params: Record<string, any> | undefined,
  schema: ParameterSchema<Record<string, any>>
): ValidationError[] {
  const errors: ValidationError[] = [];

  for (const [field, fieldSchema] of Object.entries(schema) as [string, any][]) {
    const value = params?.[field];
    const isMissing = value === undefined || value === null;

    if (isMissing) {
      if (fieldSchema.required) {
        errors.push({ field, message: `"${field}" is required` });
      }
      continue;
    }

    if (!typeCheckers[fieldSchema.type as FieldType]?.(value)) {
      errors.push({ field, message: `"${field}" must be of type ${fieldSchema.type}` });
    }
  }

  return errors;
}

export function applyDefaults(
  params: Record<string, any> | undefined,
  schema: ParameterSchema<Record<string, any>>
): Record<string, any> {
  const result = { ...params };
  for (const [field, fieldSchema] of Object.entries(schema) as [string, any][]) {
    if (result[field] === undefined && fieldSchema.default !== undefined) {
      result[field] = fieldSchema.default;
    }
  }
  return result;
}